import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 盘点状态 1草稿 2.待确认 3.确认中 4.签署中 5.已完成 6.已驳回，7.待发起，8.待签署,9.作废中,10.已作废
 */
class StockCheckState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(3, "确认中");
    TO_BE_INITIATE = new Meta(7, "待发起");
    TO_BE_SIGNED = new Meta(8, "待签署");
    SIGNING = new Meta(4, "签署中");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
    REJECTED = new Meta(6, "已驳回");
    FINISHED = new Meta(5, "抽检完成");
    // 1.4.0 录入企业，提交后"待抽检"
    TO_BE_SAMPLED = new Meta(11, "待抽检");
}
export const STOCK_CHECK_STATE = new StockCheckState();

/**
 * 盘点状态 1草稿 2.待确认 3.确认中 4.签署中 5.已完成 6.已驳回，7.待发起，8.待签署,9.作废中,10.已作废
 */
class StockCheckStatePC extends UltMeta {
    WAIT_CONFIRM = new Meta(2, "待确认");
    CONFIRMING = new Meta(3, "待确认");
    TO_BE_SIGNED = new Meta(8, "待签署");
    SIGNING = new Meta(4, "签署中");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
    FINISHED = new Meta(5, "抽检完成");
}
export const STOCK_CHECK_STATE_PC = new StockCheckStatePC();

/**
 * 盘点状态 1草稿 2.待确认 3.确认中 4.签署中 5.已完成 6.已驳回，7.待发起，8.待签署,9.作废中,10.已作废
 */
class StockCheckStateBANK extends UltMeta {
    CONFIRMING = new Meta(3, "确认中");
    TO_BE_INITIATE = new Meta(7, "待发起");
    TO_BE_SIGNED = new Meta(8, "待签署");
    SIGNING = new Meta(4, "签署中");
    INVALIDING = new Meta(9, "作废中");
    INVALID = new Meta(10, "已作废");
    FINISHED = new Meta(5, "抽检完成");
}
export const STOCK_CHECK_STATE_BANK = new StockCheckStateBANK();

/**
 * 签署方式
 */
class StockCheckSignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}
export const STOCK_CHECK_SIGN_MODE = new StockCheckSignMode();

/**
 * 抽检类型
 */
class StockCheckType extends UltMeta {
    DAILY = new Meta(1, "每日抽检");
    REGULAR = new Meta(2, "定期抽检");
    TEMPORARY = new Meta(3, "临时抽检");
    SELECTIVE = new Meta(4, "国检");
}
export const STOCK_CHECK_TYPE = new StockCheckType();

/**
 * 保存类型
 * */
class StockCheckSaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}
export const STOCK_CHECK_SAVE_TYPE = new StockCheckSaveType();

/**
 * 保存类型
 * */
class StockCheckResult extends UltMeta {
    QUALIFIED = new Meta(1, "合格");
    UNQUALIFIED = new Meta(0, "不合格");
}
export const STOCK_CHECK_RESULT = new StockCheckResult();
